import { useTranslation } from "react-i18next";
import "./ErrorPopup.css";

interface ErrorPopupProps {
  onClose: () => void;
  message?: string | null;
}

export default function ErrorPopup({ onClose, message }: ErrorPopupProps) {
  const { t } = useTranslation();

  return (
    <div className="error-popup-backdrop" onClick={onClose}>
      <div
        className="error-popup-container"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          className="error-popup-close"
          onClick={onClose}
          aria-label={t("errorPopup.close")}
          type="button"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="15"
            height="15"
            viewBox="0 0 15 15"
            fill="none"
          >
            <path
              d="M13.2 1.19995L1.20061 13.2M13.2 13.2L1.19995 1.19995"
              stroke="#E4E4E4"
              strokeWidth="2.4"
              strokeLinecap="round"
            />
          </svg>
        </button>

        <div className="error-popup-content">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="65"
            height="65"
            viewBox="0 0 65 65"
            fill="none"
            aria-hidden
          >
            <rect width="65" height="65" rx="10.8333" fill="#FFD6D6" />
            <path
              d="M32.5001 25.2482V29.4937M32.5001 37.9845H32.5213M17.7935 46.4753H47.2067C50.4748 46.4753 52.5174 42.9375 50.8833 40.1072L36.1767 14.6347C34.5427 11.8044 30.4575 11.8044 28.8234 14.6347L14.1169 40.1072C12.4828 42.9375 14.5254 46.4753 17.7935 46.4753Z"
              stroke="#DA0000"
              strokeWidth="2.71707"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>

          <div className="error-popup-texts">
            <h2 className="error-popup-heading">
              {t("generic_error.something_wents_wrong_text")}
            </h2>
            <p className="error-popup-subheading">
              {message || t("generic_error.we_could_not_complete")}
            </p>
          </div>

          <button
            className="error-popup-button"
            onClick={onClose}
            type="button"
          >
            <span>{t("generic_error.try_again_btn")}</span>
          </button>
        </div>
      </div>
    </div>
  );
}
